import React from "react";

export default function WhyAkten() {
  const features = [
    {
      title: "US-Based Active Company",
      description: "Registered and active US corporation",
      image: "https://readdy.ai/api/search-image?query=modern%20american%20warehouse%20interior%20with%20organized%20shelves%20professional%20logistics%20operations%20systematic%20inventory%20management%20clean%20industrial%20environment%20professional%20business%20setting&width=400&height=400&seq=feature-us-warehouse-001&orientation=squarish",
      icon: "ri-map-pin-line",
    },
    {
      title: "Compliance First",
      description: "Fully compliant wholesale operations",
      image: "https://readdy.ai/api/search-image?query=business%20compliance%20documents%20legal%20contract%20review%20professional%20desk%20with%20paperwork%20corporate%20legal%20environment%20organized%20business%20documentation%20professional%20office%20setting&width=400&height=400&seq=feature-compliance-002&orientation=squarish",
      icon: "ri-shield-check-line",
    },
    {
      title: "Long-Term Partnership",
      description: "Sustainable business relationships",
      image: "https://readdy.ai/api/search-image?query=bright%20modern%20corporate%20office%20two%20executives%20reviewing%20documents%20at%20conference%20table%20natural%20daylight%20floor%20to%20ceiling%20windows%20professional%20B2B%20business%20meeting%20formal%20attire%20clean%20minimal%20interior&width=400&height=400&seq=feature-partnership-corp-007&orientation=squarish",
      icon: "ri-hand-heart-line",
    },
    {
      title: "Transparent Communication",
      description: "Professional and open dialogue",
      image: "https://readdy.ai/api/search-image?query=formal%20corporate%20boardroom%20meeting%20executives%20around%20large%20conference%20table%20documents%20laptop%20strategy%20discussion%20professional%20suits%20serious%20business%20environment%20natural%20office%20lighting&width=400&height=400&seq=feature-communication-corp-008&orientation=squarish",
      icon: "ri-message-3-line",
    },
  ];

  return (
    <section id="about" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <p className="text-sm font-medium text-gray-500 tracking-wider uppercase mb-3">
            WHY AKTEN INC
          </p>
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 max-w-3xl">
            Reliable and Professional{" "}
            <span className="italic font-serif">Partnership</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="rounded-3xl overflow-hidden flex flex-col"
            >
              <div className="relative h-64 flex items-center justify-center">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-[#1a2332]/55"></div>
                <i className={`${feature.icon} text-white text-6xl relative z-10`}></i>
              </div>
              <div className="bg-white p-6 border border-gray-200 rounded-b-3xl flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-sm">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gray-50 rounded-3xl p-10 border border-gray-200">
          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 rounded-full bg-akten flex items-center justify-center flex-shrink-0">
              <i className="ri-close-circle-line text-white text-2xl"></i>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                No Arbitrage or Unauthorized Resale
              </h3>
              <p className="text-gray-600 leading-relaxed">
                We only work with authorized supply chains. We do not engage in arbitrage
                or unauthorized resale activities.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}